module.exports = __webpack_public_path__ + "static/media/screen5.c7447e69.png";